<template lang="pug">
  .history-user
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container(v-if="dataOriginal.type")
        .history-label Type
        div {{ capitalize(dataOriginal.type) }}
      .history-container(v-for="(address, index) in dataOriginal.addresses")
        .history-label {{ index === 0 ? 'Principal Address' : `Address ${index}`}}
        div {{ address }}
      .history-container(v-for="(email, index) in dataOriginal.emails")
        .history-label {{ index === 0 ? 'Principal Email' : `Email ${index}`}}
        div {{ email }}
      .history-container(v-for="(phone, index) in dataOriginal.phones")
        .history-label {{ index === 0 ? 'Principal Phone' : `Phone ${index}`}}
        div {{ phoneNumber(phone) }}
      .history-container(v-if="dataOriginal.showInPage || dataOriginal.showInPage === false")
        .history-label Show In Page
        div {{ dataOriginal.showInPage }}
      .history-container(v-if="dataOriginal.active || dataOriginal.active === false")
        .history-label Active
        div {{ dataOriginal.active }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryUser',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-user
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/user/History.vue